import NewsletterThirtyContainer from "./container/NewsletterThirtyContainer";
export default NewsletterThirtyContainer;
